import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { environment } from 'src/environments/environment';

// Initialize Firebase
const firebaseApp = initializeApp(environment.firebaseConfig);
const fbAuth = getAuth(firebaseApp);
export const auth = fbAuth;
export default firebaseApp;
